import { ContactDTO } from 'app/shared/model/contactDTO.model';
import { DocumentDTO } from 'app/shared/model/documentDTO.model';
import { FeedBackDTO } from 'app/shared/model/FeedBackDTO.model';
import axios, { AxiosResponse } from 'axios';
import asyncHandler from '../../../shared/util/asyncHandler';

export interface IClientApi {
    createContact(contact: ContactDTO): Promise<AxiosResponse<any>>;
    createFirstContact(contact: ContactDTO): Promise<AxiosResponse<any>>;
    createDocument(documents: DocumentDTO[]): Promise<AxiosResponse<any>>;
    createFeedBack(documents: FeedBackDTO): Promise<AxiosResponse<any>>;
}

class ClientApi implements IClientApi {
    async createContact(contact: ContactDTO): Promise<AxiosResponse<any>> {
        return asyncHandler(axios.post('/api/kubrick/createContact', contact));
    }
    async createFirstContact(contact: ContactDTO): Promise<AxiosResponse<any>> {
        return asyncHandler(axios.post('/api/kubrick/createFirstContact', contact));
    }
    async createDocument(documents: DocumentDTO[]): Promise<AxiosResponse<any>> {
        return asyncHandler(axios.post('/api/kubrick/createDocument', documents));
    }
    async createFeedBack(feedBack: FeedBackDTO): Promise<AxiosResponse<any>> {
        return asyncHandler(axios.post('/api/kubrick/feedbacks', feedBack));
    }
}

const clientApi = new ClientApi();

export { clientApi };
